
import {Component, Prop, Vue} from "vue-property-decorator";
import {IApp} from "@/interfaces/app.interface";
import moment from "moment";

interface ILastPay {
  date: string;
  errorMessage: string;
  status: IApp.Status;
}

@Component({})
export default class LastPayBlock extends Vue {
  @Prop() lastPay: ILastPay

  status = IApp.Status;
  printedData: { label: string; value: string; class?: string; }[] = [];

  created() {
    this.printedData = [
      { label: 'Последняя оплата', value: moment(this.lastPay.date).format(IApp.DateFormats.PrintedDateTimeFull), },
      { label: 'Статус', value: IApp.StatusLabel[this.lastPay.status], class: 'status status-text' },
      { label: 'Детально', value: this.lastPay.errorMessage, class: 'status message' },
    ];
  }


}
